import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { castArray } from 'lodash';
import { withStyles, AppBar, Paper } from '@material-ui/core';
import { withTranslation } from 'react-i18next';
import ClearIcon from '@material-ui/icons/Clear';
import { NOTIFICATIONS_ACTION_TYPES } from '../../redux-saga/actionTypes';
import images from '../../themes/assets';
import { HeaderIcon, NotificationIcons, NotificationAvatar } from '../../components';
import NotificationStatus from '../../components/NotificationStatus/NotificationStatus';

import styles from './styles';

const tempData = {
  //userid: 'f864fa4700964fd2912aad41aa9post2',
}; // vin: 1NXBR38E34Z193435

export class Notifications extends React.Component {
  notifElemRefs = [];

  componentDidMount = () => {
    this.props.getNotifications(tempData);
  };

  render() {
    const { loading, error, notifications } = this.props;
    if (loading) {
      return (
        <div>
          <span>Loading....</span>
        </div>
      );
    }
    if (error) {
      return this.renderError();
    }
    if (notifications) {
      return this.renderNotifications();
    }
    if (!notifications) {
      return <NotificationStatus />;
    }
  }

  /**
   * @name renderNotifications
   */
  renderNotifications = () => {
    const {
      classes: {
        topBar,
        listBox,
        bottomBar,
        itemDivider,
        itemDividerIcon,
        itemDividerText,
        closeButton,
        toolbarButtons,
      },
    } = this.props;

    return (
      <React.Fragment>
        <AppBar position="fixed" className={topBar}>
          <div className={closeButton}>
            <span>
              <ClearIcon />
            </span>
          </div>
        </AppBar>
        <div className={listBox}>
          <div className={itemDivider}>
            <img src={images.EventGrayIcon} className={itemDividerIcon} alt="notifications" />
            {/* <HeaderIcon /> */}
            <div className={itemDividerText}>
              Earlier Notifications
              <span className={toolbarButtons} onClick={this.props.clearAll}>
                Clear All
              </span>
            </div>
          </div>
          <div>{this.renderNotificationsItems()}</div>
        </div>
        <AppBar position="fixed" color="primary" className={bottomBar} />
      </React.Fragment>
    );
  };

  renderNotificationsItems = () => {
    const {
      notifications,
      classes: {
        itemContainer,
        itemDetails,
        itemTimeAndActions,
        itemActions,
        itemTitleText,
        itemSubtitle,
        itemAvatar,
      },
    } = this.props;
    const notifnsArr = castArray(notifications.messages);
    this.notifElemRefs = [];
    return notifnsArr.map((notification, index) => {
      const { messageid, message } = notification;
      const itemRef = React.createRef();
      this.notifElemRefs.push(itemRef);
      return (
        <Paper ref={itemRef} key={messageid} className={itemContainer}>
          <div className={`${itemAvatar}`}>
            <NotificationAvatar notification={notification} />
          </div>
          <div className={itemDetails}>
            <div className={itemTitleText}>{message}</div>
            <div className={itemSubtitle}>{notification.messageaction}</div>
          </div>
          <div className={itemTimeAndActions}>
            <div className={itemActions}>
              <NotificationIcons notification={notification} />
            </div>
          </div>
        </Paper>
      );
    });
  };

  /**
   * @name renderError
   * @description renders Error DOM
   */
  renderError = () => (
    <div>
      <span>Error....</span>
    </div>
  );

  /**
   * @name getAvatarClass
   * @description returns the style(Css) class for a given
   * notification type's avatar block as per HMI
   */
  getAvatarClass = notification => {
    const {
      classes: { calendarNaviBox, alertBox },
    } = this.props;

    if (notification.phone_number || notification.lat) {
      return calendarNaviBox;
    }
    return alertBox;
  };
}

Notifications.propTypes = {
  classes: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  notifications: PropTypes.any,
  error: PropTypes.any,
  getNotifications: PropTypes.func.isRequired,
  clearAll: PropTypes.func.isRequired,
};

Notifications.defaultProps = {
  notifications: null,
  error: null,
  selectedNotification: null,
};

const mapStateToProps = state => {
  const { loading, notifications, error, selectedNotification } = state.notifications;
  return {
    loading,
    notifications,
    error,
    selectedNotification,
  };
};

const mapDispatchToProps = dispatch => ({
  getNotifications: payload =>
    dispatch({ type: NOTIFICATIONS_ACTION_TYPES.GET.IN_PROGRESS, payload }),
  clearAll: () => dispatch({ type: NOTIFICATIONS_ACTION_TYPES.DELETE.IN_PROGRESS }),
});

const NotificationsConnected = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Notifications);

export default withStyles(styles)(withTranslation()(NotificationsConnected));
